const general = () => {
	const General = {
		init: () => {},
	};

	$(() => {
		General.init();
	});
};

export default {
	init: general,
};



// WEBPACK FOOTER //
// ./scripts/components/general.js